import { Random } from 'roughjs/bin/math';
/**
 * A simple random number generator that allows for seeding.
 */
export class RandomNumberGenerator {
    constructor(seed) {
        // since we already depend on Rough.js, we may just use its seedable RNG implementation
        this.rng = seed ? new Random(seed) : null;
    }
    /**
     * Returns a random number in the given range.
     */
    next(range) {
        var _a, _b;
        const rnd = (_b = (_a = this.rng) === null || _a === void 0 ? void 0 : _a.next()) !== null && _b !== void 0 ? _b : Math.random();
        if (range) {
            const min = range[0];
            const max = range[1];
            return rnd * (max - min) + min;
        }
        return rnd;
    }
}
